import { render } from "./BseShowBaka.vue?vue&type=template&id=32d89162"
import script from "./BseShowBaka.vue?vue&type=script&lang=js"
export * from "./BseShowBaka.vue?vue&type=script&lang=js"

import "./BseShowBaka.vue?vue&type=style&index=0&id=32d89162&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__